export const sharedConstants = {
  IS_GALLERY_UPLOAD_PREVIEW: "IS_GALLERY_UPLOAD_PREVIEW",
  KB_TO_MB_BYTES: 1048576, //1024 * 1024 = 1048576
  EVENT_NAME: "eventName",
  OBJECT: "object",
};

export const localStorageKeys = {
  ACTIVE_TAB: "activeTab",
  ADD_RECAPZ: "addRecapz",
  ADD_CANCELLED_RECAPZ: "addCancelledRecapz",
  EDIT_EVENTS: "editEvents",
  DATA_TO_SEND: "dataToSend",
  TOTAL_EVENTS: "totalEvents",
  DRAFT_EVENTS: "draftEvents",
  IS_EDIT_EVENT: "isEditEvent",
  IS_DRAFT_EVENT: "isDraftEvent",
  ADD_RECAPZ_BACKUP: "ADD_RECAPZ_BACKUP",
  EVENT_ALREADY_EXIST: "eventAlreadyExist",
  ADD_RECAPZ_ACTIVE_STEP: "addRecapActiveStep",
  SHUTTERB_TIP_EXTEND_CART: "shutterBTipExtendCart",
  USE_SAME_LOGO_FOR_ALL_RECAPS: "useSameLogoForAllRecaps",
  BILLING_DETAILS: "billingDetails",
  MISC_AMOUNTS_OLD: "miscOldAmount",
};

export const EMPTY_STRING = "";
export const UNDEFINED = "undefined";
export const NUMBER = "number";

export const inputTypeConstants = {
  TEXT: "text",
  PASSWORD: "password",
};

export const DATE_PICKER_FORMAT = "MM/dd/yyyy";
export const SPACE = " ";

export const ACCEPTED_IMAGE_TYPES = ".png,.jpg, .jpeg";
export const MAX_IMAGE_SIZE_MB = 5; // Mb

export const DEXIE_TABLENAME = {
  LOGOS: "logos",
};

export const TIME_FIELDS = {
  HOURS: "hours",
  MINUTES: "minutes",
  SECONDS: "seconds",
};

export const VIDEO_DURATION = {
  DEFAULT: 50000, // Default video duration in seconds
};

export const CURRENCY_SYMBOL = {
  DOLLAR: "$",
  PERCENT: "%",
};

export const TRUE = "true";
export const FALSE = "false";

export const FILE_EXTENSIONS = {
  PNG: "png",
  JPG: "jpg",
  JPEG: "jpeg",
  GIF: "gif",
  MP4: "mp4",
  MOV: "mov",
  HEIC: "heic",
  HEIF: "heif",
};

export const MEDIA_TYPES = {
  IMAGE: "image",
  VIDEO: "video",
};

export const MEDIA_MIME_TYPES = {
  MP4: "video/mp4",
  MOV: "video/mov",
  M4V: "video/m4v",
  JPEG: "image/jpeg",
};

export const VIDEO_EXTENSIONS = {
  MP4: [".mp4", ".MP4"],
  MOV: [".mov", ".MOV"],
  M4V: [".m4v", ".M4V"],
};

export const BASE64_IMAGE_PREFIX = "data:image";

export const ZERO = 0;

export const IS_ACTIVE = {
  TRUE: true,
  FALSE: false,
};

export const DEFAULT_PHONE_COUNTRY = {
  COUNTRY: "+1",
};

export const timeZone = {
  UTC: "UTC",
};

// Numeric constants
export const numberConstants = Object.freeze({
  ZERO: 0,
  ONE: 1,
  TWO: 2,
  ONE_HUNDRED: 100,
});
